import { format } from 'date-fns';
import { bg, deAT, enGB, es, fr } from 'date-fns/locale';
import { CommonLocals } from './common-locals';
import { getUTCDate } from './get-utc-date';

export function formatDate(locale: CommonLocals, date: string | number | Date) {
  if (!date) return '';

  const utcMode = process.env.NEXT_PUBLIC_UTC_DATE === 'true';

  return format(utcMode ? getUTCDate(date) : date, 'dd MMM yyyy', {
    locale: getDateLocale(locale),
  });
}

export function getDateLocale(locale: CommonLocals) {
  switch (locale) {
    case 'de':
      return deAT;
    case 'es':
      return es;
    case 'fr':
      return fr;
    case 'bg':
      return bg;
    default:
      return enGB;
  }
}
